import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
import UserUtils from 'utils/user-utils';
import getReservationStatus from 'segment/utils/reservation-status';

export default function trackCancellationFailed({
    reservation,
    user,
    activeStatus,
    refundReason,
    refundDestination,
}) {
    try {
        const {status} = user;
        const {
            reservationType,
            facility,
            rentalId,
            paymentStatus,
            partner,
            priceBreakdown: {totalPrice},
        } = reservation;
        const reservationStatus = getReservationStatus({
            activeStatus,
            paymentStatus,
        });

        const properties = {
            parking_type: reservationType,
            refund_destination: refundDestination,
            refund_reason: refundReason,
            refund_amount: totalPrice,
            facility_id: facility.id,
            rental_id: rentalId,
            reservation_status: reservationStatus,
            user_logged_in: status === UserUtils.AUTH_STATE.USER,
            partner: partner?.slug || null,
        };

        SegmentUtils.track({
            event: 'Cancellation Failed',
            properties,
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 1,
                    },
                },
            },
        });
    } catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Event Failed - cancellationFailed',
        });
    }
}
